import { useEffect, useRef, useState } from "react";
import { IInvitationResponse } from "@wingspanhq/users/dist/lib/interfaces/api/invitation";
import { UserStatus } from "@wingspanhq/users/dist/lib/interfaces/newUser";
import {
  redirectToV3SignIn,
  shouldRedirectToV3
} from "../../../Auth/utils/v3LoginRedirect";
import { useMutationIdentifyAuthentication } from "../../../query/users/mutations";

/** Checks a loaded, registered invitee once before allowing the v2 sign-in form. */
export function useInvitationV3Redirect(invitationData?: IInvitationResponse) {
  const [checkComplete, setCheckComplete] = useState(false);
  const processed = useRef(false);
  const [identifyAuth] = useMutationIdentifyAuthentication();
  const email = invitationData?.invitee.email;
  const isActive = invitationData?.invitee.status === UserStatus.Active;

  useEffect(() => {
    if (!isActive || !email || processed.current) {
      return;
    }

    processed.current = true;

    /** Keeps the form hidden if navigation starts, otherwise preserves v2 sign-in. */
    const performRedirect = async () => {
      try {
        const response = await identifyAuth({ email }, { throwOnError: true });

        if (
          response &&
          shouldRedirectToV3(response) &&
          redirectToV3SignIn(email)
        ) {
          return;
        }
      } catch {
        // A failed routing check must not block the existing invitation flow.
      }

      setCheckComplete(true);
    };

    performRedirect();
  }, [email, isActive, identifyAuth]);

  // Derive this before the effect runs so the sign-in form never flashes.
  return { isRedirecting: isActive && !!email && !checkComplete };
}
